/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import {UserProvider, setConfig} from './src/porter-package/';

setConfig({applicationName: 'beamfire'});

export const wrapRootElement = ({element}) =>
	<UserProvider>{element}</UserProvider>;
